import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { queryKeys, staleTimes } from '../config/queryClient';

/**
 * Hook para obtener las redes sociales de una sucursal
 * 
 * @param {number} shopBranchId - ID de la sucursal
 * @param {object} options - Opciones adicionales
 * @returns {object} - { data: socialMedia[], isLoading, error }
 */
export const useSocialMedia = (shopBranchId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.socialMedia(shopBranchId),
    
    queryFn: async () => {
      const response = await axios.get(
        process.env.REACT_APP_API_SOCIALMEDIA_ROUTE,
        {
          params: {
            status: true,
            shopBranchId,
          },
        }
      );
      return response.data;
    },
    
    enabled: !!shopBranchId,
    
    // Redes sociales raramente cambian
    staleTime: staleTimes.static, // 1 hora
    
    cacheTime: 2 * 60 * 60 * 1000, // 2 horas
    
    ...options,
  });
};

/**
 * Hook helper para obtener una red social específica
 */
export const useSocialMediaByType = (shopBranchId, socialMediaType) => {
  const { data: socialMedia = [] } = useSocialMedia(shopBranchId);
  
  return socialMedia.find((red) => red.socialMediaType === socialMediaType);
};

/**
 * Hooks específicos por tipo de red social
 */
export const useInstagram = (shopBranchId) => {
  const social = useSocialMediaByType(shopBranchId, 'INSTAGRAM');
  return social?.socialMediaLink || '';
};

export const useFacebook = (shopBranchId) => {
  const social = useSocialMediaByType(shopBranchId, 'FACEBOOK');
  return social?.socialMediaLink || '';
};

export const usePhoneNumber = (shopBranchId) => {
  const social = useSocialMediaByType(shopBranchId, 'PHONENUMBER');
  return social?.socialMediaLink || '';
};
